import moment from "moment";
export function enumerateDaysBetweenDates(
  startDate,
  endDate,
  format = "YYYY-MM-DD",
  duration = "days"
) {
  let date = [];

  while (moment(startDate, format) <= moment(endDate, format)) {
    date.push(moment(startDate, format).format(format));
    startDate = moment(startDate).add(1, duration).format(format);
  }
  return date;
}
